import React, { useEffect, useState } from 'react';
import {Link, Redirect} from 'react-router-dom';
import './header.css';
import { AuthorizationContext } from '../../context/authorizationContext';
import Logout from '../../api/logout/logout';
import Loader from '../loader/loader';

const Header = () => {
    const { flagLoggedin, userDetail, path } = React.useContext(AuthorizationContext);
    const [visible_loader, setVisibleLoader] = useState(false);

    const LogoutFun = ()=>{
        setVisibleLoader(true);
        Logout({}, (res)=>{
            // console.log("Printing response of logging out API call from header.jsx", res);
            // window.location.href = "https://onboard-harshil.web.app/";
            window.location.href = "https://onboard-10.web.app/"
            
            if(res.data.status === true){
                setVisibleLoader(false);
            }
            else{
                setVisibleLoader(false);
            }
        }, (error)=>{
            setVisibleLoader(false);
            // console.log("Got error from logginout in header.jsx",error);
            console.log("e out", error);
        })
    }

    return (
        flagLoggedin !== true ? 
        <>
            {visible_loader === true && <Loader />}
            <nav className="navbar navbar-expand-lg fixed-top">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">OnBoard</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav  nav nav-pills" role="tablist">
                            <li className="nav-item">
                                <Link className={"nav-link"} aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link  className={"nav-link"} to="/login">Login</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </> : <>
        {visible_loader === true && <Loader />}
            <nav className="navbar navbar-expand-lg fixed-top">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">OnBoard</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav  nav nav-pills" role="tablist">
                            <li className="nav-item">
                                <Link className={"nav-link"} aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link  className={"nav-link"} to="/tasks">{userDetail?.admin === true ? "Manage" : "View"} Work</Link>
                            </li>
                            {userDetail?.admin &&  <li className="nav-item">
                                <Link className={"nav-link"} to="/add/task">Add Work</Link>
                            </li>}
                            {userDetail?.admin &&  <li className="nav-item">
                                <Link className={"nav-link"} to="/history">History</Link>
                            </li>}
                            <li className="nav-item">
                                <Link className={'nav-link'} to="/company">Company</Link>
                            </li>
                            <li className='nav-item'>
                                <Link to="/contact" className={"nav-link"}>Contact</Link>
                            </li>
                            <li className='nav-item'>
                                <Link to="/about" className={"nav-link"}>About</Link>
                            </li>
                            <li>
                                <div className="dropdown">
                                    <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        Profile
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <Link 
                                            // onClick={()=>{
                                            //     window.location.href = "https://onboard-harshil.web.app/profile";
                                            // }} 
                                            to="/profile" className="dropdown-item">Profile</Link>
                                            </li>
                                        <li><Link onClick={()=>{LogoutFun()}} className="dropdown-item">Logout</Link></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
};

export default Header;